import { Component, Vue } from "vue-property-decorator";
import { getApplicationDetails } from "@/providers/apis/getApplictionDetails";
import { utils } from "@/utils/utils";
import { ReviewerpeerPreviewInterface } from "@/models/reviewer-peers-page/reviewer-peers.interface";
import moment from "moment";
import AppLoaderComponent from "../app-loader/app-loader.component.vue";
import PreviewPopupComponent from "../preview-popup/preview-popup.component.vue";
import { appConfigService } from "@/providers/services/app/app-config";
import EmailModalPopupComponent from "../email-modal-popup/email-modal-popup.component.vue";
import RevokeCertificatePopupComponent from "../revoke-certificate-popup/revoke-certificate-popup.component.vue";
import { PEER_FLAG_APPLICANT_QUERY } from "@/graphql/peer-flag-applicant";
import { gql } from "graphql-tag";
import { flagApplicantApi } from "@/providers/apis/peers-flag-applicant";
import { trainingFormApi } from "@/providers/apis/certification-part-one-form";
import { certificationFormApi } from "@/providers/apis/certification-part-two-form";
import { renewalFormApi } from "@/providers/apis/cprs-renewal-application";
import { stateToStateFormApi } from "@/providers/apis/state-to-state-form";
import { endorsementFormApi } from "@/providers/apis/endorsement-form";
import { adminUploadsApi } from "@/providers/apis/admin-uploads";
import { commonService } from "@/providers/services/common-service";
@Component({
  name: "reviewer-peers-preview",
  components: {
    AppLoaderComponent,
    PreviewPopupComponent,
    EmailModalPopupComponent,
    RevokeCertificatePopupComponent,
  },
})
export default class ReviewerPeersPreview extends Vue {
  public isLoading = false;
  public errorMessage = "";
  public profileData: any = [];
  public certificationData: any = [];
  // Disable/Revoke admin actions are only for a Part Two certification, even
  // when certificationData falls back to a State-to-State application.
  public hasPartTwoCertification = false;
  public file: any = null;
  public showPreviewPopup = false;
  public tableHeader = [
    { key: "applicationTitle", label: "Application Name" },
    { key: "submittedAt", label: "Submission Date" },
    { key: "progressStatus", label: "Status" },
    { key: "action", label: "Action" },
  ];
  public applicationData = [];
  public imgType = ["jpg", "png", "jpeg", "tiff"];
  public getCertificatesFilesPathUrl = "";
  public previewData: any[] = [];
  public isReport: any;
  public emailData: any = null;
  public flagApplicantGrapqlRevoke: any = {};
  public flagHistoryDataApi: any = {};
  public disablePeerProfileEnable = false;
  public peerApplicationDisable: any;
  // The template reads .length on this during the first render, before the
  // applications API resolves — so it must start as an array, not undefined.
  public isShowImpersonate: any = [];
  public thumnailData = "";
  public S3Path = "";
  public revokeUnrevokeCertificate = false;
  public peerRevokeUnRevoke: any;
  /**
   * The peer's real user id, taken from the applications response.
   *
   * Not the same thing as the route's ?id=, which is the peers-view row key
   * (`SELECT email FROM <app>.peers WHERE id = :id`) - a hash the backend
   * resolves to an email and then to a user. Anything that wants a userId has
   * to use this, not the route param.
   */
  public peerUserId = "";
  // Admin Uploads tab
  public activeTab = "applications";

  /**
   * Phone only: the profile is a panel that slides in over the applications
   * rather than a column beside them. Closed on arrival, since the
   * applications are what the reviewer came for.
   */
  public isProfileOpen = false;
  public adminDocuments: any[] = [];
  public adminDocumentsLoading = false;
  public adminUploadForm: any = {
    documentName: "",
    description: "",
    visibleToPeer: false,
  };
  public selectedFile: any = null;
  public uploadInProgress = false;
  public uploadError = "";
  // Per-field messages for the two required fields; empty string means valid.
  public uploadFieldErrors: any = { documentName: "", file: "" };
  // certificate previews resolve against the certificates S3 path; admin
  // uploaded documents resolve against the general files S3 path.
  public previewIsPeer = true;
  public deleteDocumentTarget: any = null;
  // Id of the document whose visibility is mid-update, and the last failure.
  public visibilityUpdatingId: any = null;
  public visibilityError = "";
  public imageExtensions = ["jpg", "jpeg", "png", "tiff"];
  // Kept in step with the file input's accept attribute and the hint text.
  public allowedUploadExtensions = [
    ".pdf",
    ".doc",
    ".docx",
    ".jpg",
    ".jpeg",
    ".png",
  ];
  public maxUploadSizeMb = 10;
  public get maxUploadBytes(): number {
    return this.maxUploadSizeMb * 1024 * 1024;
  }
  // Document details drawer: read-only view of what the admin filled in at
  // upload time. Visibility is the exception — it stays changeable from here.
  public detailsDocument: any = null;
  get basicDetails() {
    if (!this.profileData || !this.profileData.data) return {};
    return (
      this.profileData.data.certificationPartOneBasicDetails ||
      this.profileData.data.stateToStateBasicDetails ||
      {}
    );
  }
  public created() {
    const id: any = this.$route.query.id;
    this.getCertificatesFilesPathUrl =
      appConfigService.getS3CertificatesFilesPathUrl();
    this.getPeerApplicationLists(id);
    this.flagApplicantGrapqlQuery();
    this.flagHistoryApi();
    this.S3Path = appConfigService.getS3FilesPathUrl();
  }
  public flagApplicantGrapqlQuery() {
    this.$apollo
      .query({
        query: gql`query ${PEER_FLAG_APPLICANT_QUERY}`,
      })
      .then((result) => {
        this.flagApplicantGrapqlRevoke = result;
      });
  }
  public getPeerApplicationLists(id: string) {
    this.isLoading = true;
    getApplicationDetails
      .getPeersPreviewApplicationList({ id: id })
      .then((response) => {
        this.thumnailData = response.thumbnail;
        this.peerApplicationDisable = response.isDisabled;
        this.peerRevokeUnRevoke = response.isRevoked;
        this.peerUserId = response.userId;
        this.applicationData = response.appplications.sort((a: any, b: any) => {
          return (
            new Date(b.submittedAt).getTime() -
            new Date(a.submittedAt).getTime()
          );
        });
        this.isLoading = false;
        this.profileData = this.applicationData.find(
          (data: ReviewerpeerPreviewInterface) => {
            return data.applicationName === "PART ONE";
          }
        );
        if (!this.profileData) {
          this.profileData = this.applicationData.find(
            (data: ReviewerpeerPreviewInterface) => {
              return data.applicationName === "STATE TO STATE";
            }
          );
        }
        // The profile certification comes from an ACCEPTED Part Two; if the
        // peer has no Part Two, fall back to an ACCEPTED State-to-State
        // application — it carries the same certificateNumber / expiryDate /
        // certificateFile, so the same certification block can render it.
        const acceptedPartTwo = this.applicationData.filter(
          (data: ReviewerpeerPreviewInterface) =>
            data &&
            data.progressStatus === "ACCEPTED" &&
            data.applicationName === "PART TWO"
        );
        const acceptedStateToState = this.applicationData.filter(
          (data: ReviewerpeerPreviewInterface) =>
            data &&
            data.progressStatus === "ACCEPTED" &&
            data.applicationName === "STATE TO STATE"
        );
        // The peer's CPRS certificate: Part Two, or State-to-State for a peer
        // who transferred in rather than certifying here.
        this.certificationData = acceptedPartTwo.length
          ? acceptedPartTwo
          : acceptedStateToState;
        this.hasPartTwoCertification = acceptedPartTwo.length > 0;
        // The endorsement is ADDITIONAL, not an alternative: a peer earns
        // CPRS-J on top of the certificate that made them eligible for it, so
        // it is appended rather than replacing the branch above. Only once a
        // certificate has actually been issued - an accepted endorsement with
        // no file is not a certification yet.
        const acceptedEndorsement = this.applicationData.filter(
          (data: ReviewerpeerPreviewInterface) =>
            data &&
            data.progressStatus === "ACCEPTED" &&
            data.applicationName === "ENDORSEMENT" &&
            !!data.certificateFile
        );
        this.certificationData =
          this.certificationData.concat(acceptedEndorsement);
        this.applicationData.forEach((data: ReviewerpeerPreviewInterface) => {
          // certificateFile arrives as a JSON string (or null); parse once.
          data.certificateFile = data.certificateFile
            ? JSON.parse(data.certificateFile)
            : null;
          // Reviewers know this endorsement as CPRS-J; "Endorsement" is the
          // internal applicationName and should not surface in the UI.
          data.applicationTitle =
            data.applicationName === "ENDORSEMENT"
              ? "Endorsement"
              : `${data.applicationName.toLowerCase()} Application`;
          // What the certification row calls itself. Part Two and
          // State-to-State both certify a peer recovery specialist; the
          // endorsement is a different credential and should say so. Named
          // "Endorsement" to match applicationTitle just above and the rest of
          // the UI - CPRS-J is what the codebase calls it, not what the screens
          // do.
          data.certificationLabel =
            data.applicationName === "ENDORSEMENT"
              ? "Endorsement"
              : "Certified peer recovery specialist";
          data.submittedAt = data.submittedAt
            ? moment(data.submittedAt).format("MM-DD-YYYY")
            : "--";
          // "--" is the applications table's placeholder for a missing date.
          // An endorsement genuinely has no expiry, and the certification row
          // has to be able to tell "no date" from "a date", so leave it empty
          // there and let the table supply its own placeholder.
          data.expiryDate = data.expiryDate
            ? moment(data.expiryDate).format("MM-DD-YYYY")
            : "";
        });
        this.isShowImpersonate = this.applicationData.filter(
          (application: any) => {
            return (
              application &&
              application.progressStatus === "ACCEPTED" &&
              application.applicationName === "PART ONE"
            );
          }
        );
        // basicDetails (and its email) are now available — load admin documents.
        this.fetchAdminDocuments();
      })
      .catch((error) => {
        this.errorMessage = utils.errorMessage(error);
        this.isLoading = false;
      });
  }

  public previewForm(row: any) {
    let query;
    if (this.$route.query.isReport) {
      query = {
        id: this.$route.query.id,
        application: row.item.applicationName,
        type: this.$route.query.type,
        isReport: this.$route.query.isReport,
        fromDate: this.$route.query.fromDate,
        toDate: this.$route.query.toDate,
      };
      if (this.$route.query.ethnicity) {
        Object.assign(query, { ethnicity: this.$route.query.ethnicity });
      }
      if (this.$route.query.gender) {
        Object.assign(query, { gender: this.$route.query.gender });
      }
      if (this.$route.query.region) {
        Object.assign(query, { region: this.$route.query.region });
        Object.assign(query, { regionId: this.$route.query.regionId });
      }
      if (this.$route.query.age) {
        Object.assign(query, { age: this.$route.query.age });
        Object.assign(query, { fromAge: this.$route.query.fromAge });
        Object.assign(query, { toAge: this.$route.query.toAge });
      }
      if (this.$route.query.education) {
        Object.assign(query, { education: this.$route.query.education });
      }
    } else {
      query = {
        id: this.$route.query.id,
        application: row.item.applicationName,
      };
    }
    this.$router.push({
      path: `peers-preview/${row.item.id}`,
      query: query,
    });
  }
  public previewCertificationForm(content: any) {
    this.previewIsPeer = true;
    this.file = content.certificateFile;
    if (this.file) {
      const img = new Image();
      this.previewData = [
        {
          width: img.width,
          height: img.height,
          type: this.file.type,
          originalFileName: this.file.originalFileName,
          uploadedFileName: this.file.uploadedFileName,
        },
      ];
      this.showPreviewPopup = true;
    }
  }
  public hidePreviewPopup(event: boolean) {
    if (event === true) {
      this.showPreviewPopup = false;
      this.previewData = [];
    }
  }
  public backUrl() {
    let filter = "";
    if (this.$route.query.ethnicity) {
      filter += `&ethnicity=${this.$route.query.ethnicity}`;
    }
    if (this.$route.query.gender) {
      filter += `&gender=${this.$route.query.gender}`;
    }
    if (this.$route.query.region) {
      filter += `&region=${this.$route.query.region}&regionId=${this.$route.query.regionId}`;
    }
    if (this.$route.query.age) {
      filter += `&age=${this.$route.query.age}&fromAge=${this.$route.query.fromAge}&toAge=${this.$route.query.toAge}`;
    }
    if (this.$route.query.education) {
      filter += `&education=${this.$route.query.education}`;
    }
    return this.$route.query.isReport
      ? `/reviewer-dashboard/peers?type=${this.$route.query.type}&isReport=${this.$route.query.isReport}&fromDate=${this.$route.query.fromDate}&toDate=${this.$route.query.toDate}${filter}`
      : "/reviewer-dashboard/peers";
  }
  public onOpenModal(row: any) {
    // The recipient is always this peer, so seed the row with the profile
    // email. The popup still overrides it per application type where the
    // application data carries its own email (and falls back to this).
    if (row && row.item && !row.item.email) {
      row.item.email = this.basicDetails?.email;
    }
    this.emailData = row;
    this.$bvModal.show("email-modal");
  }
  // Peer-level "overall" email: no application context, so applicationId is
  // null and the peer's userId is sent instead. Recipient is the profile email.
  public onOpenOverallEmail() {
    this.emailData = {
      item: {
        isOverall: true,
        applicationName: null,
        id: null,
        email: this.basicDetails?.email,
        userId: this.peerUserId,
      },
    };
    this.$bvModal.show("email-modal");
  }
  public emailSentStatus(event: boolean) {
    if (event) {
      this.$bvModal.hide("email-modal");
    }
  }

  public RevokeCertificatePopupClose() {
    this.disablePeerProfileEnable = false;
    this.$bvModal.hide("revoke-certificate-modal");
    const id: any = this.$route.query.id;
    this.getPeerApplicationLists(id);
    this.flagHistoryApi();
  }
  public flagHistoryApi() {
    flagApplicantApi
      .peersFlagHistory({ id: this.$route.query.id })
      .then((res) => {
        this.flagHistoryDataApi = res;
      });
  }
  public revokeCertification() {
    this.revokeUnrevokeCertificate = true;
    this.$bvModal.show("revoke-certificate-modal");
  }
  public disablePeerProfile() {
    this.disablePeerProfileEnable = true;
    this.revokeUnrevokeCertificate = false;
    this.$bvModal.show("revoke-certificate-modal");
  }
  public impersonateUser() {
    const id: any = this.$route.query.id;
    getApplicationDetails.getImpersonate({ id: id }).then((response) => {
      const accessToken: any = localStorage.getItem("access_token");
      const userDetail: any = localStorage.getItem("user_details");
      localStorage.setItem("admin_access_token", accessToken);
      localStorage.setItem("admin_user_details", userDetail);
      localStorage.setItem("access_token", response.access_token);
      localStorage.setItem("user_details", JSON.stringify(response));
      localStorage.setItem("profileData", userDetail);
      this.$router.push({
        path: `/user-dashboard/home`,
        query: {
          id: id,
          type: "admin",
        },
      });
      localStorage.setItem("impersonateId", id);
      window.location.reload();
    });
  }
  public showDelete = appConfigService.getShowDelete();
  public deleteTargetId = "";
  public deleteApplicationName = "";
  public deleteApplicationTitle = "";
  public deleteSubmittedAt = "";
  public deleteProgressStatus = "";
  public deleteSuccess = false;

  public confirmDelete(row: any) {
    this.deleteTargetId = row.item.id;
    this.deleteApplicationName = row.item.applicationName;
    this.deleteApplicationTitle = row.item.applicationTitle;
    this.deleteSubmittedAt = row.item.submittedAt;
    this.deleteProgressStatus = row.item.progressStatus || "";
    this.deleteSuccess = false;
    this.$bvModal.show("delete-application-modal-peers");
  }

  public cancelDelete() {
    this.deleteSuccess = false;
    this.$bvModal.hide("delete-application-modal-peers");
  }

  public submitDelete() {
    const id: any = this.$route.query.id;
    let deleteCall: Promise<any>;
    switch (this.deleteApplicationName) {
      case "PART ONE":
        deleteCall = trainingFormApi.deleteTrainingApplication(
          this.deleteTargetId
        );
        break;
      case "PART TWO":
        deleteCall = certificationFormApi.deleteCertificateApplication(
          this.deleteTargetId
        );
        break;
      case "RENEWAL":
        deleteCall = renewalFormApi.deleteRenewalApplication(
          this.deleteTargetId
        );
        break;
      case "STATE TO STATE":
        deleteCall = stateToStateFormApi.deleteStateToStateApplication(
          this.deleteTargetId
        );
        break;
      case "ENDORSEMENT":
        deleteCall = endorsementFormApi.deleteEndorsementApplication(
          this.deleteTargetId
        );
        break;
      default:
        return;
    }
    this.isLoading = true;
    deleteCall
      .then(() => {
        this.isLoading = false;
        this.deleteSuccess = true;
        this.getPeerApplicationLists(id);
        setTimeout(() => {
          this.$bvModal.hide("delete-application-modal-peers");
          this.deleteSuccess = false;
        }, 5000);
      })
      .catch((error) => {
        this.errorMessage = utils.errorMessage(error);
        this.isLoading = false;
      });
  }

  public deleteProfilePic() {
    this.$bvModal.show("profile-pic-delete");
  }
  public cancelProfilePic() {
    this.$bvModal.hide("profile-pic-delete");
  }
  public submitProfilePic() {
    this.isLoading = true;
    getApplicationDetails
      .getPeersProfilePicDelete({ id: this.$route.query.id })
      .then((res: any) => {
        if (res.status == 204) {
          const id: any = this.$route.query.id;
          this.$bvModal.hide("profile-pic-delete");
          this.getPeerApplicationLists(id);
        }
      });
  }

  // ------------------------- Admin Uploads -------------------------

  public switchTab(tab: string) {
    this.activeTab = tab;
  }

  public fetchAdminDocuments() {
    // Admin documents are keyed by the peer's email, which is only available
    // once the peer's applications (and basicDetails) have loaded.
    const email: any = this.basicDetails && this.basicDetails.email;
    if (!email) {
      return;
    }
    this.adminDocumentsLoading = true;
    adminUploadsApi
      .getPeerDocuments(email)
      .then((response: any) => {
        this.adminDocuments = (response && response.documents) || [];
        this.adminDocumentsLoading = false;
      })
      .catch((error) => {
        this.errorMessage = utils.errorMessage(error);
        this.adminDocumentsLoading = false;
      });
  }

  public openUploadModal() {
    this.adminUploadForm = {
      documentName: "",
      description: "",
      visibleToPeer: false,
    };
    this.selectedFile = null;
    this.uploadError = "";
    this.uploadFieldErrors = { documentName: "", file: "" };
    this.$bvModal.show("admin-upload-modal");
  }

  public closeUploadModal() {
    this.$bvModal.hide("admin-upload-modal");
  }

  // The input's accept attribute only filters the file picker — drag-and-drop
  // and the picker's "All Files" option both get past it, so the choice is
  // validated here before it can be uploaded.
  public acceptFile(file: any) {
    const extension = "." + (file.name || "").split(".").pop().toLowerCase();
    if (!this.allowedUploadExtensions.includes(extension)) {
      this.selectedFile = null;
      this.uploadError = "Upload a PDF, Word document, or image file.";
      return;
    }
    if (file.size > this.maxUploadBytes) {
      this.selectedFile = null;
      this.uploadError = `"${file.name}" is ${this.formatFileSize(
        file.size
      )}. Files must be ${this.maxUploadSizeMb}MB or smaller.`;
      return;
    }
    this.selectedFile = file;
    this.uploadError = "";
    this.uploadFieldErrors.file = "";
  }

  public onFileSelect(event: any) {
    const files = event.target.files || event.dataTransfer.files;
    if (files && files.length) {
      this.acceptFile(files[0]);
    }
  }

  public onFileDrop(event: any) {
    event.preventDefault();
    const files = event.dataTransfer.files;
    if (files && files.length) {
      this.acceptFile(files[0]);
    }
  }

  public removeSelectedFile() {
    this.selectedFile = null;
  }

  // Both required fields are reported at once, so the admin sees everything
  // that needs fixing rather than one error at a time.
  private validateUploadForm(): boolean {
    this.uploadFieldErrors = {
      documentName: this.adminUploadForm.documentName
        ? ""
        : "Document name is required",
      file: this.selectedFile ? "" : "A document is required",
    };
    return !this.uploadFieldErrors.documentName && !this.uploadFieldErrors.file;
  }

  public submitUpload() {
    if (!this.validateUploadForm()) {
      return;
    }
    this.uploadInProgress = true;
    this.uploadError = "";
    commonService
      .uploadFile([this.selectedFile])
      .then((result: any) => {
        const fileBlock = (result && result.data) || [];
        const uploaded = fileBlock.find((data: any) => !(data instanceof File));
        if (!uploaded || !uploaded.fileName) {
          this.uploadInProgress = false;
          this.uploadError = "File upload failed, please try again";
          return;
        }
        const payload = {
          userId: this.peerUserId,
          email: this.basicDetails && this.basicDetails.email,
          documentName: this.adminUploadForm.documentName,
          description: this.adminUploadForm.description,
          fileName: uploaded.fileName,
          originalFileName: uploaded.originalFileName || this.selectedFile.name,
          contentType: this.selectedFile.type,
          visibleToPeer: this.adminUploadForm.visibleToPeer,
        };
        return adminUploadsApi.createPeerDocument(payload).then(() => {
          this.uploadInProgress = false;
          this.closeUploadModal();
          this.fetchAdminDocuments();
        });
      })
      .catch((error) => {
        this.uploadInProgress = false;
        this.uploadError = utils.errorMessage(error);
      });
  }

  public toggleVisibility(document: any) {
    // Ignore repeat clicks while the previous change is still in flight, so a
    // double click cannot fire two opposing updates.
    if (this.visibilityUpdatingId === document.id) {
      return;
    }
    const updatedVisibility = !document.visible_to_peer;
    this.visibilityUpdatingId = document.id;
    this.visibilityError = "";
    adminUploadsApi
      .updateDocumentVisibility(document.id, updatedVisibility)
      .then(() => {
        document.visible_to_peer = updatedVisibility;
        this.visibilityUpdatingId = null;
      })
      .catch((error) => {
        // The pill stays on its old value, so without a message the click just
        // looks like it did nothing.
        this.visibilityUpdatingId = null;
        this.visibilityError = utils.errorMessage(error);
      });
  }

  public confirmDeleteDocument(document: any) {
    this.deleteDocumentTarget = document;
    this.$bvModal.show("admin-upload-delete-modal");
  }

  public cancelDeleteDocument() {
    this.deleteDocumentTarget = null;
    this.$bvModal.hide("admin-upload-delete-modal");
  }

  public deleteDocument() {
    if (!this.deleteDocumentTarget) {
      return;
    }
    adminUploadsApi
      .deletePeerDocument(this.deleteDocumentTarget.id)
      .then(() => {
        this.$bvModal.hide("admin-upload-delete-modal");
        this.deleteDocumentTarget = null;
        this.fetchAdminDocuments();
      })
      .catch((error) => {
        this.errorMessage = utils.errorMessage(error);
      });
  }

  public openDocumentDetails(document: any) {
    this.detailsDocument = document;
    this.visibilityError = "";
    this.$bvModal.show("admin-document-details-modal");
  }

  public closeDocumentDetails() {
    this.$bvModal.hide("admin-document-details-modal");
    this.detailsDocument = null;
    this.visibilityError = "";
  }

  public previewDocument(document: any) {
    this.previewIsPeer = false;
    this.previewData = [
      {
        type: document.content_type,
        originalFileName: document.original_file_name,
        uploadedFileName: document.file_name,
        fileName: document.file_name,
      },
    ];
    this.showPreviewPopup = true;
  }

  public async downloadDocument(document: any) {
    const fileUrl = `${this.S3Path}/${document.file_name}`;
    try {
      const response = await fetch(fileUrl);
      const blob = await response.blob();
      const link = window.document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = document.original_file_name || document.file_name;
      link.click();
      URL.revokeObjectURL(link.href);
    } catch (error) {
      this.errorMessage = utils.errorMessage(error);
    }
  }

  public documentExtension(document: any) {
    const name = document.original_file_name || document.file_name || "";
    return name.split(".").pop().toLowerCase();
  }

  // Short badge label shown against the file-type icon (PDF / DOC / IMG).
  public documentTypeLabel(document: any) {
    const ext = this.documentExtension(document);
    if (this.imageExtensions.includes(ext)) {
      return "IMG";
    }
    if (ext === "pdf") {
      return "PDF";
    }
    if (ext === "doc" || ext === "docx") {
      return "DOC";
    }
    return ext.toUpperCase().substring(0, 4);
  }

  public documentIconClass(document: any) {
    const ext = this.documentExtension(document);
    if (this.imageExtensions.includes(ext)) {
      return "doc-icon-img";
    }
    if (ext === "pdf") {
      return "doc-icon-pdf";
    }
    return "doc-icon-doc";
  }

  public formatFileSize(bytes: number) {
    if (!bytes && bytes !== 0) {
      return "--";
    }
    if (bytes < 1024) {
      return `${bytes} B`;
    }
    if (bytes < 1024 * 1024) {
      return `${(bytes / 1024).toFixed(0)} KB`;
    }
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  }

  public formatDocumentDate(date: string) {
    return date ? moment(date).format("MMM DD, YYYY") : "--";
  }
}
